import { useCurrentPermissionsStore } from '@onereach/permissions-ui';
import { defineStore } from 'pinia';
import { computed } from 'vue';

const usePermissionsStore = defineStore('permissions', () => {
  const store = useCurrentPermissionsStore();

  const has = (permission: string) => store.hasPermission(permission);

  return {
    getCurrentPermissions: store.getCurrentPermissions,
    noAccess: computed(() => store.noAccess),
    canEditAccounts: computed(() => has('accounts.edit')),
    canEditSkuMapping: computed(() => has('sku-mapping.edit')),
    canEditCustomers: computed(() => has('customers.edit')),
    canManageCustomerAccounts: computed(() => has('customers.manage-accounts')),
    canEditContacts: computed(() => has('contacts.edit')),
    canEditContracts: computed(() => has('contracts.edit')),
    canEditVendors: computed(() => has('vendors.edit')),
    canEditPaymentProviders: computed(() => has('payment-providers.edit')),
    canEditReportingDatabase: computed(() => has('reporting-database.edit')),
    canEditSkus: computed(() => has('sku.edit')),
    canEditUsers: computed(() => has('users.edit')),
    canEditErroredSkus: computed(() => has('errored-skus.edit')),
    canEditEnvironments: computed(() => has('environments.edit')),
    canEditProgressiveTiers: computed(() => has('progressive-tiers.edit')),
    canEditTiers: computed(() => has('tiers.edit')),
    canViewAccounts: computed(() => has('accounts.view')),
    canRevealReportingDatabasePassword: computed(() => has('reporting-database.reveal-password')),
    canConfigureReportingDatabaseCron: computed(() => has('reporting-database.configure-cron')),
    canCreateSageAccrual: computed(() => has('sage-accrual.create')),
    canManageFlows: computed(() => has('flows.manage')),
  };
});

export default usePermissionsStore;
